// CAT Mock 5 — QA section.
const catMock5Qa = [
  {
    id: 47,
    type: "mcq",
    question: "A shopkeeper marks an article 40% above its cost price and then allows two successive discounts of 10% each. What is his profit percentage?",
    options: [
      "A. 12%",
      "B. 20%",
      "C. 13.4%",
      "D. 15.6%"
    ],
    answer: "C"
  },
  {
    id: 48,
    type: "tita",
    question: "Pipe A can fill a tank in 12 hours and pipe B can fill it in 15 hours, while pipe C can empty the full tank in 20 hours. If all three pipes are opened together on an empty tank, in how many hours will the tank be full?",
    answer: "10"
  },
  {
    id: 49,
    type: "mcq",
    question: "How many zeros are there at the end of 125! (125 factorial)?",
    options: [
      "A. 30",
      "B. 31",
      "C. 32",
      "D. 29"
    ],
    answer: "B"
  },
  {
    id: 50,
    type: "tita",
    question: "In how many distinct ways can the letters of the word BANANA be arranged?",
    answer: "60"
  },
  {
    id: 51,
    type: "mcq",
    question: "The sides of a triangle are 13 cm, 14 cm and 15 cm. What is the radius of the circle inscribed in the triangle?",
    options: [
      "A. 3 cm",
      "B. 5 cm",
      "C. 4.5 cm",
      "D. 4 cm"
    ],
    answer: "D"
  },
  {
    id: 52,
    type: "tita",
    question: "The average weight of 30 students in a class is 50 kg. When the teacher's weight is included, the average weight increases by 1 kg. What is the teacher's weight (in kg)?",
    answer: "81"
  },
  {
    id: 53,
    type: "mcq",
    question: "If x + 1/x = 4, what is the value of x³ + 1/x³?",
    options: [
      "A. 64",
      "B. 56",
      "C. 52",
      "D. 48"
    ],
    answer: "C"
  },
  {
    id: 54,
    type: "tita",
    question: "If log₂x + log₄x + log₁₆x = 7, what is the value of x?",
    answer: "16"
  },
  {
    id: 55,
    type: "mcq",
    question: "A bag contains 5 red, 4 blue and 3 green balls. Three balls are drawn at random without replacement. What is the probability that all three are of different colours?",
    options: [
      "A. 1/4",
      "B. 2/11",
      "C. 5/22",
      "D. 3/11"
    ],
    answer: "D"
  },
  {
    id: 56,
    type: "tita",
    question: "How many ordered triples (x, y, z) of positive integers satisfy x + y + z = 15?",
    answer: "91"
  },
  {
    id: 57,
    type: "mcq",
    question: "A train 240 m long passes a pole in 12 seconds and a platform in 20 seconds. What is the length of the platform?",
    options: [
      "A. 160 m",
      "B. 180 m",
      "C. 200 m",
      "D. 140 m"
    ],
    answer: "A"
  },
  {
    id: 58,
    type: "tita",
    question: "What is the remainder when 7¹⁰⁰ is divided by 9?",
    answer: "7"
  },
  {
    id: 59,
    type: "mcq",
    question: "The roots of the equation x² − 5x + k = 0 differ by 3. What is the value of k?",
    options: [
      "A. 6",
      "B. 4",
      "C. 3",
      "D. 2"
    ],
    answer: "B"
  },
  {
    id: 60,
    type: "tita",
    question: "A and B start together from the same point on a circular track 600 m long and run in opposite directions at constant speeds of 4 m/s and 6 m/s respectively. If they keep running indefinitely, at how many distinct points on the track will they meet?",
    answer: "5"
  },
  {
    id: 61,
    type: "mcq",
    question: "A sum of money invested at compound interest (compounded annually) amounts to ₹12,100 in 2 years and to ₹13,310 in 3 years. What is the sum invested?",
    options: [
      "A. ₹9,000",
      "B. ₹10,500",
      "C. ₹11,000",
      "D. ₹10,000"
    ],
    answer: "D"
  },
  {
    id: 62,
    type: "tita",
    question: "Each interior angle of a regular polygon measures 150°. How many diagonals does the polygon have?",
    answer: "54"
  },
  {
    id: 63,
    type: "mcq",
    question: "What is the area of the region in the xy-plane defined by |x| + |y| ≤ 4?",
    options: [
      "A. 16 sq. units",
      "B. 64 sq. units",
      "C. 32 sq. units",
      "D. 24 sq. units"
    ],
    answer: "C"
  },
  {
    id: 64,
    type: "tita",
    question: "A 60-litre mixture contains milk and water in the ratio 2 : 1. How many litres of water must be added to make the ratio of milk to water 1 : 2?",
    answer: "60"
  },
  {
    id: 65,
    type: "mcq",
    question: "A car travels from P to Q at 40 km/h and returns from Q to P along the same route at 60 km/h. What is its average speed for the whole journey?",
    options: [
      "A. 48 km/h",
      "B. 50 km/h",
      "C. 52 km/h",
      "D. 45 km/h"
    ],
    answer: "A"
  },
  {
    id: 66,
    type: "tita",
    question: "How many integer values of x satisfy |x − 3| + |x + 2| ≤ 9?",
    answer: "10"
  },
  {
    id: 67,
    type: "mcq",
    question: "How many integers from 1 to 300 (both inclusive) are divisible by 3 or 5 but not by 7?",
    options: [
      "A. 126",
      "B. 114",
      "C. 130",
      "D. 120"
    ],
    answer: "D"
  },
  {
    id: 68,
    type: "tita",
    question: "The sum of the first 10 terms of an arithmetic progression is 155 and the sum of its first 20 terms is 610. What is the 15th term of the progression?",
    answer: "44"
  }
];

export default catMock5Qa;
